import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions'

import EditAccountForm from './EditAccountForm';

class EditAccountPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      account: Object.assign({}, this.props.account),
      errors: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  handleChange(event) {
    const field = event.target.name;
    let account = this.state.account;
    account[field] = event.target.value;

    return this.setState({account: account});
  }

  handleSave(event){
    event.preventDefault();
    this.props.actions.updateAccount(this.state.account);
    // this.context.router.history.push('/account/view/'+this.state.account.id);
    this.context.router.history.push('/accounts');
  }

  componentDidMount(){
    
  }
  render() {
    return (
      <div className="genericPageContainer">
        <div className="genericTitleBar">Email They Entered</div>
        <div className="genericPageWrap grey">
          <EditAccountForm
            account={this.state.account}
            onSubmit={this.handleSave}
            onChange={this.handleChange}
            errors={this.state.errors}
          />
        </div>
      </div>
    );
  }
}

EditAccountPage.propTypes = {
  actions: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired
};

EditAccountPage.contextTypes = {
  router: PropTypes.object
};

function  getAccountById(accounts, id) {
  const account = accounts.filter(account => account.id === id);
  if(account) return account[0];
  return null;
}

function mapStateToProps(state, ownProps) {

  const accountId = ownProps.match.params.id;
  let account;
  if(accountId) account = getAccountById(state.accounts, accountId);
  if(!account) {
    account = {
      id: accountId,
      accountName: '',
      address: '',
      adminName: '',
      mobileNumber: ''
    };
  }

  return {
    account: account
  }
}

function matchDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, matchDispatchToProps) (EditAccountPage);



// WEBPACK FOOTER //
// ./src/components/account/EditAccountPage.js